// extracted by mini-css-extract-plugin
export default {"Error404":"Error404__Error404--jz076","Error404__error":"Error404__Error404__error--HG2CR"};